import React from 'react'
import { useNavigatorOnline } from '../hooks'
import ErrorIcon from '../images/error.svg'
import OfflineIcon from '../images/offline.svg'

import {
  SOMETHING_WENT_WRONG,
  RELOAD
} from '../trans'


const Error = (props) => {
  let { className = '', text = SOMETHING_WENT_WRONG, reload = false, icon=<ErrorIcon/>} = props
  className += " error__dimmer"
  return (
    <div className={className}>
      { icon }
      { text }
      { reload  && <button onClick={ ()=> window.location.reload(true)} className="button raised"> {RELOAD} </button> }
    </div>
  )
}

export const ErrorReloading = (props) =>{
  if (navigator.onLine){
      return <Error {...props} reload={true} />
    } else {
      return <Error {...props} reload={false} icon={<OfflineIcon/>} />
  }
}

export default Error
